import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  CwipCapitaliseRequest, CwipLine, CwipProject, CwipProjectRequest,
} from '../interfaces/fixedAsset/cwip.interface';

export const CwipService = {
  list: async (institutionId: string): Promise<CwipProject[]> =>
    (await axios.get(ENDPOINTS.CWIP_PROJECT.LIST(institutionId))).data,
  get: async (id: string): Promise<CwipProject> =>
    (await axios.get(ENDPOINTS.CWIP_PROJECT.BY_ID(id))).data,
  create: async (req: CwipProjectRequest): Promise<CwipProject> =>
    (await axios.post(ENDPOINTS.CWIP_PROJECT.CREATE, req)).data,
  update: async (id: string, req: CwipProjectRequest): Promise<CwipProject> =>
    (await axios.put(ENDPOINTS.CWIP_PROJECT.BY_ID(id), req)).data,
  cancel: async (id: string): Promise<CwipProject> =>
    (await axios.post(ENDPOINTS.CWIP_PROJECT.CANCEL(id))).data,
  linkable: async (id: string): Promise<CwipLine[]> =>
    (await axios.get(ENDPOINTS.CWIP_PROJECT.LINKABLE(id))).data,
  link: async (id: string, lineIds: string[]): Promise<CwipProject> =>
    (await axios.post(ENDPOINTS.CWIP_PROJECT.LINKS(id), { lineIds })).data,
  unlink: async (id: string, linkId: string): Promise<CwipProject> =>
    (await axios.delete(ENDPOINTS.CWIP_PROJECT.LINK(id, linkId))).data,
  capitalise: async (id: string, req: CwipCapitaliseRequest): Promise<CwipProject> =>
    (await axios.post(ENDPOINTS.CWIP_PROJECT.CAPITALISE(id), req)).data,
  reverse: async (id: string): Promise<CwipProject> =>
    (await axios.post(ENDPOINTS.CWIP_PROJECT.REVERSE(id))).data,
};
